import { useState, type FormEvent } from "react";
import { useLocale } from "../hooks/useLocale";
import styles from "./ClarifyPrompt.module.css";

interface Props {
  question: string;
  busy?: boolean;
  onSubmit: (answer: string) => void;
}

export function ClarifyPrompt({ question, busy = false, onSubmit }: Props) {
  const { t } = useLocale();
  const [answer, setAnswer] = useState("");

  function submit(e: FormEvent) {
    e.preventDefault();
    const trimmed = answer.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
    setAnswer("");
  }

  return (
    <div className={styles.card}>
      <span className={styles.label}>{t("chat.clarify_title")}</span>
      <p className={styles.question}>{question}</p>
      <form onSubmit={submit} className={styles.form}>
        <input
          autoFocus
          className={styles.input}
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          maxLength={20000}
          disabled={busy}
        />
        <button
          type="submit"
          className={styles.submit}
          disabled={busy || !answer.trim()}
        >
          {t("chat.clarify_send")}
        </button>
      </form>
    </div>
  );
}
